import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import { minutesToTimeSpan } from '@/shared/utils/adminpulse';
import messages from '../capacityPlanningMessages';
const DefaultChange = ({ current, next }) => {
    const intl = useIntl();
    if (current == null && next == null)
        return _jsx("span", Object.assign({ className: "text-muted" }, { children: intl.formatMessage(messages.NoData) }));
    if (current === next)
        return (_jsxs("span", { children: [minutesToTimeSpan(current), ' ', _jsxs("span", Object.assign({ className: "text-muted" }, { children: ["(", intl.formatMessage(messages.NoChange), ")"] }))] }));
    return (_jsxs("span", Object.assign({ className: "text-warning" }, { children: [current == null ? intl.formatMessage(messages.NoDefault) : minutesToTimeSpan(current), " \u2192", ' ', minutesToTimeSpan(next)] })));
};
export default DefaultChange;
